import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

export const AccountButtonStyleValues = {
  menuWidth: '14.5rem',
  menuMaxHeight: '40vh',
  chevronBoxSize: '0.75rem',
}

const AccountButtonStyleParts = ['leftIcon', 'rightIcon'] as const

const helpers = createMultiStyleConfigHelpers(AccountButtonStyleParts)
export const AccountButtonStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    leftIcon: {
      boxSize: '1.25rem',
    },
    rightIcon: {
      boxSize: '0.75rem',
    },
  },
})

export const useAccountButtonStyle = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof AccountButtonStyleParts>(
    getName({ AccountButtonStyle }),
    props,
  )
}
